import jwt from 'jsonwebtoken'

interface IPayload {
  UserId: string
  IsGlobalAdmin: boolean
  UserName: string
}

interface IJwt {
  payload: {
    payload: string
    exp: number
  }
}

const isJwtValid = () => {
  const token: string = `${localStorage.getItem('token')}`

  const decodedAccessToken = jwt.decode(token, { complete: true, json: true })
  if (!decodedAccessToken) {
    localStorage.removeItem('token')
    return false
  }

  const payload = (decodedAccessToken as IJwt).payload

  const isValid = payload.exp * 1000 > new Date().getTime()

  if (!isValid) {
    localStorage.removeItem('token')
  }

  return isValid
}

export const getJwtToken = () => {
  return `${localStorage.getItem('token')}`
}

export const getJwtCredentials = (token: string) => {
  const decodedAccessToken = jwt.decode(token, { complete: true, json: true })

  const payload = (decodedAccessToken as IJwt).payload.payload

  return JSON.parse(payload) as IPayload
}

export default isJwtValid
